import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDeletePermissionOverride = (matterId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<void, Error, { overrideId: string }>({
    mutationFn: async ({ overrideId }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.DELETE,
      });
      const response = await fetch(
        `${APIBaseChronos}/api/matters/${matterId}/permission-overrides/${overrideId}`,
        fetchConfig,
      );
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message ?? 'Failed to remove Matter-level override');
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries([QueryEntity.PermissionOverrides, { matterId }]);
      queryClient.invalidateQueries([QueryEntity.Matter, { matterId }]);
      toast.success('Matter-level permission removed');
    },
    onError: () => {
      toast.error('Failed to remove Matter-level permission');
    },
  });
};
